import { AppointmentModel } from '@devexpress/dx-react-scheduler';
import React, { createContext } from 'react';
import { Schedule } from 'store/schedules/interfaces';

export interface UpdateWorkScheduleParams {
  schedule: AppointmentModel;
  triggerApiCall?: boolean;
  onSuccess?: () => void;
}

export type CountValue = 1 | 7;

export interface ScheduleCalendarContextProps {
  workSchedules: AppointmentModel[];
  isDraftCreating: boolean;
  schedule: Schedule;
  handleAddDraftWorkSchedule: (draftWorkSchedule: AppointmentModel) => void;
  updateEndDateOfDraftWorkSchedule: (newEndDate: Date) => void;
  setIsDraftCreating: React.Dispatch<React.SetStateAction<boolean>>;
  handleAddDraftScheduleToWorkSchedules: () => void;
  handleRemoveWorkSchedule: (id: AppointmentModel['id']) => void;
  handleUpdateWorkSchedule: ({
    schedule,
    triggerApiCall,
  }: UpdateWorkScheduleParams) => Promise<void>;
  draftAnchorEl: HTMLDivElement | null;
  setDraftAnchorEl: React.Dispatch<React.SetStateAction<HTMLDivElement | null>>;
  handleIncreaseScheduleDays: (countValue: CountValue) => void;
  handleDecreaseScheduleDays: (countValue: CountValue) => void;
}

export const ScheduleCalendarContext = createContext<
  ScheduleCalendarContextProps | undefined
>(undefined);
